module.exports = __webpack_public_path__ + "static/media/error-modal.83e1f5ab.svg";